import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Collapsible from '../../../../../../../1stlog-ui/src/components/Collapsible'
import ListGroup from '../../../../../../../1stlog-ui/src/components/ListGroup'
import Product from '../Product'

const ListGroupCustom = styled(ListGroup)`
  margin-top: -5px;
`

const ProductGroup = (props) => {
  const { title, products, isPickup } = props

  if (lodash.isEmpty(products)) {
    return null
  }

  const listComponent = (
    <ListGroupCustom flush className="mb-2">
      {lodash.map(products, (product) => (
        <Product product={product} isPickup={isPickup} />
      ))}
    </ListGroupCustom>
  )

  if (!title) {
    return listComponent
  }

  return (
    <Collapsible title={title} isInitiallyExpanded>
      {listComponent}
    </Collapsible>
  )
}

export default ProductGroup
